var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v("Safe Drops For "+_vm._s(_vm.location))]),_c('div',{staticStyle:{"width":"250px"}},[_c('BasicTableComponent',{attrs:{"list":_vm.safeData,"tableID":_vm.location + '_SafeDrops',"formatters":{
          'Date' : ['d', 'ddd MM/DD/YY'], 
          
          'SafeDropsCount' : ['n', '0,0'],
          'SafeDrops' : ['n', '0,0.00'],  
          
        },"titles":{
        'Date' : 'Date',
        'SafeDrops' : 'Safe Drops',
        'Other' : 'Other (exceptions)',
        'SafeDropsCount' : 'Safe Drops Count',
      },"totals":_vm.totals,"actionNames":{
          Date: (a,b,val)=>{
            _vm.clickDate(a,b,val)
          },
        }}})],1),(_vm.safeTransactions)?_c('div',{staticStyle:{"width":"600px"}},[_c('h5',[_vm._v("Safe Transactions For "+_vm._s(_vm.location))]),_c('BasicTableComponent',{attrs:{"list":_vm.safeTransactions,"tableID":_vm.location + '_Transactions',"hideColumns":['ID', 'Store_ID'],"formatters":{
        'DateTime' : ['d', 'ddd MM/DD/YY h:mm:ss a'],
        'Amount' : ['n', '0,0.00'],
        'Type' : ['n', '0'],
      },"columnOrder":['DateTime', 'Cashier_ID', 'Override_ID', 'Amount'],"totals":_vm.transactionsTotals}}),_c('p',[_vm._v("End of transactions for "+_vm._s(_vm.location))])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }